module.exports = __webpack_public_path__ + "static/pregnancy-f7b6d88bcaa4d2273bd4cb602f1a8ca1.png";